export default {
  "9142A": [
    { from: "formVersionId", to: "formVersionId" },
    { from: "empIsContractor", to: "a2_is_contractor" },
    { from: "empBusinessName", to: "b1_emp_legal_name" },
    { from: "empTradeName", to: "b2_emp_dba" },
    { from: "emppocLastname", to: "c1_poc_last" },
    { from: "emppocFirstname", to: "c2_poc_first" },
    { from: "emppocMiddlename", to: "c3_poc_middle" },
    { from: "emppocJobtitle", to: "c4_poc_title" },
    { from: "emppocAddr1", to: "c5_poc_address_1" },
    { from: "emppocAddr2", to: "c6_poc_address_2" },
    { from: "emppocCity", to: "c7_poc_city" },
    { from: "emppocState", to: "c8_poc_state_id", type: "state" },
    { from: "emppocPostcode", to: "c9_poc_zip" },
    { defaultValue: "UNITED STATES OF AMERICA", to: "c10_poc_country_id" },
    { from: "emppocPhone", to: "c12_poc_phone" },
    { from: "emppocPhoneext", to: "c13_poc_phone_ext" },
    { from: "emppocEmail", to: "c14_poc_email" },
    { from: "empFein", to: "b12_emp_fein" },
    { from: "empNaics", to: "b13_emp_naics" },
    { from: "empNaicsDesc", to: "b13_emp_naics_description" },
  ],
};
